import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, FINANCE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @muhammedburakak
 */

const ApprovedCODReportsList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, width: 70, show: false },
			{
				Header: 'clientName',
				accessor: 'clientName',
				filterType: FilterType.string
			},
			{
				Header: 'clientPlan',
				accessor: 'clientPlan',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CLIENT_PLANS
			},
			{
				Header: 'bankName',
				accessor: 'bankName',
				filterType: FilterType.string
			},
			{
				Header: 'bankIban',
				accessor: 'bankIban',
				filterType: FilterType.string
			},
			{
				Header: 'bankHolderName',
				accessor: 'bankHolderName',
				filterType: FilterType.string
			},
			{
				Header: 'startDate',
				accessor: 'startDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'endDate',
				accessor: 'endDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'clientBalance',
				accessor: 'clientBalance',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'automaticCODTransfer',
				accessor: 'automaticCODTransfer',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'totalAmount',
				accessor: 'totalAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'currency',
				accessor: 'currency',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.CURRENCY
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.string,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'bankCode',
				accessor: 'bankCode',
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.APPROVED_COD_REPORTS}
				columns={columns}
				fetchUrl={FINANCE.GET_APPROVED_COD_REPORTS_LIST}
				exportName="approvedCODReports"
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				defaultSort={defaultSort}
			/>
		</TabTableContainer>
	);
};

export default ApprovedCODReportsList;
